/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ChallengeCategoryDto } from './challenge-category-dto';

/**
 * 
 * @export
 * @interface UpdateChallengeResponseDto
 */
export interface UpdateChallengeResponseDto {
    /**
     * Unique identifier
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'deletedAt': string;
    /**
     * Title of the challenge
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'title': string;
    /**
     * Detailed description of the challenge
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'description': string;
    /**
     * Promotional description of the challenge for marketing purposes
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'promotionalDescription'?: string | null;
    /**
     * ID of the organizer
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'organizerId': string;
    /**
     * Whether the challenge is active
     * @type {boolean}
     * @memberof UpdateChallengeResponseDto
     */
    'isActive': boolean;
    /**
     * Whether the challenge should be promoted/featured
     * @type {boolean}
     * @memberof UpdateChallengeResponseDto
     */
    'shouldPromote': boolean;
    /**
     * URL of the cover image
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'coverImageUrl': string;
    /**
     * Array of other image URLs
     * @type {Array<string>}
     * @memberof UpdateChallengeResponseDto
     */
    'otherImagesUrl': Array<string>;
    /**
     * Challenge start date and time in UTC
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'startsAt': string;
    /**
     * Challenge end date and time in UTC
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'endsAt': string;
    /**
     * Array of updated challenge category options
     * @type {Array<ChallengeCategoryDto>}
     * @memberof UpdateChallengeResponseDto
     */
    'challengeCategories': Array<ChallengeCategoryDto>;
    /**
     * Challenge status derived from dates and isActive flag
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'challengeStatus': UpdateChallengeResponseDtoChallengeStatusEnum;
    /**
     * Success message
     * @type {string}
     * @memberof UpdateChallengeResponseDto
     */
    'message': string;
}

export const UpdateChallengeResponseDtoChallengeStatusEnum = {
    NotStarted: 'not_started',
    Ongoing: 'ongoing',
    Ended: 'ended',
    Cancelled: 'cancelled'
} as const;

export type UpdateChallengeResponseDtoChallengeStatusEnum = typeof UpdateChallengeResponseDtoChallengeStatusEnum[keyof typeof UpdateChallengeResponseDtoChallengeStatusEnum];


